import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Button, Modal, ModalBody, Table, Card, CardBody, Collapse } from 'reactstrap'
import { AiOutlineCheck } from 'react-icons/ai'
import { MdAssignment } from 'react-icons/md'
import { FiSend, FiTruck, FiSettings } from 'react-icons/fi'
import { FaFileSignature } from 'react-icons/fa'
import moment from 'moment'

// tracking pengadaan (disalin dari modal tracking di pages/Pengadaan/Pengadaan.js)
// data dari pengadaan.detailIo, panggil action pengadaan.getDetail sebelum dibuka
class TrackingPengadaan extends Component {
    state = {
        collap: false,
        tipeCol: '',
        history: false
    }

    showCollap = (val) => {
        if (val === 'close') {
            this.setState({ collap: false })
        } else {
            this.setState({ collap: false })
            setTimeout(() => {
                this.setState({ collap: true, tipeCol: val })
            }, 500)
        }
    }

    openHistory = () => {
        this.setState({ history: !this.state.history })
    }

    render() {
        const detailTrack = this.props.pengadaan.detailIo || []
        return (
            <>
            <ModalBody>
                <Row className='trackTitle ml-4'>
                    <Col>
                        Tracking Pengadaan Asset
                    </Col>
                </Row>
                <Row className='ml-4 trackSub'>
                    <Col md={3}>
                        Kode Area
                    </Col>
                    <Col md={9}>
                        : {detailTrack[0] === undefined ? '' : detailTrack[0].kode_plant}
                    </Col>
                </Row>
                <Row className='ml-4 trackSub'>
                    <Col md={3}>
                        Area
                    </Col>
                    <Col md={9}>
                        : {detailTrack[0] === undefined ? '' : detailTrack[0].area}
                    </Col>
                </Row>
                <Row className='ml-4 trackSub'>
                    <Col md={3}>
                        No Pengadaan
                    </Col>
                    <Col md={9}>
                        : {detailTrack[0] === undefined ? '' : detailTrack[0].no_pengadaan}
                    </Col>
                </Row>
                <Row className='ml-4 trackSub'>
                    <Col md={3}>
                        Tanggal Pengajuan
                    </Col>
                    <Col md={9}>
                        : {detailTrack[0] === undefined ? '' : moment(detailTrack[0].tglIo === null ? detailTrack[0].createdAt : detailTrack[0].tglIo).locale('idn').format('DD MMMM YYYY ')}
                    </Col>
                </Row>
                <Row className='ml-4 trackSub1'>
                    <Col md={12}>
                        <Button color='success' size='md' onClick={this.openHistory}>Full History</Button>
                    </Col>
                </Row>
                <div className="steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x padding-bottom-1x">
                    <div className="step completed">
                        <div className="step-icon-wrap">
                            <button className="step-icon" onClick={() => this.showCollap('Submit')} ><FiSend size={40} className="center1" /></button>
                        </div>
                        <h4 className="step-title">Submit</h4>
                    </div>
                    <div className={detailTrack[0] === undefined ? 'step' : detailTrack[0].status_form > 1 ? "step completed" : 'step'}>
                        <div className="step-icon-wrap">
                            <button className="step-icon" onClick={() => this.showCollap('Verifikasi Aset')}><FiSettings size={40} className="center" /></button>
                        </div>
                        <h4 className="step-title">Verifikasi Aset</h4>
                    </div>
                    <div className={detailTrack[0] === undefined ? 'step' : detailTrack[0].status_form > 2 ? "step completed" : 'step'} >
                        <div className="step-icon-wrap">
                            <button className="step-icon" onClick={() => this.showCollap('Pengajuan')}><MdAssignment size={40} className="center" /></button>
                        </div>
                        <h4 className="step-title">Approval Form IO</h4>
                    </div>
                    <div className={detailTrack[0] === undefined ? 'step' : detailTrack[0].status_form > 3 ? "step completed" : 'step'}>
                        <div className="step-icon-wrap">
                            <button className="step-icon" onClick={() => this.showCollap('Proses Budget')}><FiSettings size={40} className="center" /></button>
                        </div>
                        <h4 className="step-title">Proses Budget</h4>
                    </div>
                    <div className={detailTrack[0] === undefined ? 'step' : parseInt(detailTrack[0].status_form) === 8 ? "step completed" : 'step'}>
                        <div className="step-icon-wrap">
                            <button className="step-icon" onClick={() => this.showCollap('Eksekusi')}><FiTruck size={40} className="center" /></button>
                        </div>
                        <h4 className="step-title">Eksekusi Pengadaan Aset</h4>
                    </div>
                    <div className={detailTrack[0] === undefined ? 'step' : parseInt(detailTrack[0].status_form) === 8 ? "step completed" : 'step'}>
                        <div className="step-icon-wrap">
                            <button className="step-icon"><AiOutlineCheck size={40} className="center" /></button>
                        </div>
                        <h4 className="step-title">Selesai</h4>
                    </div>
                </div>
                <Collapse isOpen={this.state.collap} className="collapBody">
                    <Card className="cardCollap">
                        <CardBody>
                            <div className='textCard1'>{this.state.tipeCol} Pengadaan Asset</div>
                            <div>Rincian Item:</div>
                            <Table striped bordered responsive hover className="tableDis mb-3">
                                <thead>
                                    <tr>
                                        <th>Qty</th>
                                        <th>Description</th>
                                        <th>Price/unit</th>
                                        <th>Total Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {detailTrack.length !== 0 && detailTrack.map(item => {
                                        return (
                                            <tr key={item.id}>
                                                <td>{item.qty}</td>
                                                <td>{item.nama}</td>
                                                <td>Rp {item.price === null ? 0 : item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</td>
                                                <td>Rp {((parseInt(item.price) || 0) * (parseInt(item.qty) || 0)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                            {detailTrack[0] === undefined || this.state.tipeCol === 'Submit' ? (
                                <div></div>
                            ) : (
                                <div>
                                    <div className="mb-4 mt-2">Tracking {this.state.tipeCol} :</div>
                                    {this.state.tipeCol === 'Pengajuan' ? (
                                        <div className="steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x padding-bottom-1x">
                                            {detailTrack[0].appForm !== undefined && detailTrack[0].appForm.length > 0 && detailTrack[0].appForm.slice(0).reverse().map(item => {
                                                return (
                                                    <div key={item.id} className={item.status === 1 ? 'step completed' : item.status === 0 ? 'step reject' : 'step'}>
                                                        <div className="step-icon-wrap">
                                                            <button className="step-icon"><FaFileSignature size={30} className="center2" /></button>
                                                        </div>
                                                        <h5 className="step-title">{item.status === null ? '' : moment(item.updatedAt).format('DD-MM-YYYY')} </h5>
                                                        <h4 className="step-title">{item.status === null ? '' : item.nama}</h4>
                                                        <h4 className="step-title">{item.jabatan}</h4>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    ) : this.state.tipeCol === 'Eksekusi' ? (
                                        <div className="steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x padding-bottom-1x">
                                            <div className={parseInt(detailTrack[0].status_form) === 9 || parseInt(detailTrack[0].status_form) === 8 ? "step completed" : 'step'}>
                                                <div className="step-icon-wrap">
                                                    <button className="step-icon" ><FaFileSignature size={30} className="center2" /></button>
                                                </div>
                                                <h4 className="step-title">Filling No Asset</h4>
                                            </div>
                                            <div className={parseInt(detailTrack[0].status_form) === 8 ? "step completed" : 'step'}>
                                                <div className="step-icon-wrap">
                                                    <button className="step-icon" ><AiOutlineCheck size={30} className="center2" /></button>
                                                </div>
                                                <h4 className="step-title">Selesai</h4>
                                            </div>
                                        </div>
                                    ) : this.state.tipeCol === 'Verifikasi Aset' ? (
                                        <div className="steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x padding-bottom-1x">
                                            <div className={detailTrack[0].status_form === '1' || parseInt(detailTrack[0].status_form) > 1 ? "step completed" : 'step'}>
                                                <div className="step-icon-wrap">
                                                    <button className="step-icon" ><FaFileSignature size={30} className="center2" /></button>
                                                </div>
                                                <h4 className="step-title">Verifikasi Aset atau Non Asset</h4>
                                            </div>
                                            <div className={parseInt(detailTrack[0].status_form) > 1 ? "step completed" : 'step'}>
                                                <div className="step-icon-wrap">
                                                    <button className="step-icon" ><AiOutlineCheck size={30} className="center2" /></button>
                                                </div>
                                                <h4 className="step-title">Selesai</h4>
                                            </div>
                                        </div>
                                    ) : this.state.tipeCol === 'Proses Budget' && (
                                        <div className="steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x padding-bottom-1x">
                                            <div className={parseInt(detailTrack[0].status_form) === 3 || parseInt(detailTrack[0].status_form) > 3 ? "step completed" : 'step'}>
                                                <div className="step-icon-wrap">
                                                    <button className="step-icon" ><FaFileSignature size={30} className="center2" /></button>
                                                </div>
                                                <h4 className="step-title">Filling No Io</h4>
                                            </div>
                                            <div className={parseInt(detailTrack[0].status_form) > 3 ? "step completed" : 'step'}>
                                                <div className="step-icon-wrap">
                                                    <button className="step-icon" ><AiOutlineCheck size={30} className="center2" /></button>
                                                </div>
                                                <h4 className="step-title">Selesai</h4>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </CardBody>
                    </Card>
                </Collapse>
            </ModalBody>
            <Modal isOpen={this.state.history} toggle={this.openHistory}>
                <ModalBody>
                    <div className='mb-4'>History Transaksi</div>
                    <div className='history'>
                        {detailTrack.length > 0 && detailTrack[0].history !== null && detailTrack[0].history.split(',').map((item, index) => {
                            return (
                                item !== null && item !== 'null' &&
                                <Button key={index} className='mb-2' color='info'>{item}</Button>
                            )
                        })}
                    </div>
                </ModalBody>
            </Modal>
            </>
        )
    }
}

const mapStateToProps = state => ({
    pengadaan: state.pengadaan
})

export default connect(mapStateToProps)(TrackingPengadaan)
